import { render, staticRenderFns } from "./banner-bg.vue?vue&type=template&id=130d12c7&scoped=true"
import script from "./banner-bg.vue?vue&type=script&lang=js"
export * from "./banner-bg.vue?vue&type=script&lang=js"
import style0 from "./banner-bg.vue?vue&type=style&index=0&id=130d12c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d12c7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/interview/banner-bg.vue
// module id = null
// module chunks = 